module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-d2500139.png";